/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SuggestionActionResultType = "Autopilot" | "ConfigureSettings" | "Decline" | "Fyi" | "Invite" | "RemoveAttendee" | "RequestToMove" | "Reschedule" | "ViewMeeting" | "ViewProfile" | "ViewTeamDashboard" | "%future added value";
export type MarkSeenFeedSuggestionMutationInput = {
    clientMutationId?: string | null | undefined;
    feedSuggestionRelayId: string;
    primaryActionTaken?: SuggestionActionResultType | null | undefined;
};
export type MarkSeenFeedSuggestionMutationVariables = {
    input: MarkSeenFeedSuggestionMutationInput;
};
export type MarkSeenFeedSuggestionMutationResponse = {
    readonly markSeenFeedSuggestion: {
        readonly clientMutationId: string | null;
    } | null;
};
export type MarkSeenFeedSuggestionMutation = {
    readonly response: MarkSeenFeedSuggestionMutationResponse;
    readonly variables: MarkSeenFeedSuggestionMutationVariables;
};



/*
mutation MarkSeenFeedSuggestionMutation(
  $input: MarkSeenFeedSuggestionMutationInput!
) {
  markSeenFeedSuggestion(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "MarkSeenFeedSuggestionMutationPayload",
            "kind": "LinkedField",
            "name": "markSeenFeedSuggestion",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "MarkSeenFeedSuggestionMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "MarkSeenFeedSuggestionMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "bbf73a741091d29978b68d459783f33a",
            "id": null,
            "metadata": {},
            "name": "MarkSeenFeedSuggestionMutation",
            "operationKind": "mutation",
            "text": "mutation MarkSeenFeedSuggestionMutation(\n  $input: MarkSeenFeedSuggestionMutationInput!\n) {\n  markSeenFeedSuggestion(input: $input) {\n    clientMutationId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '32a17ecfb73dbe62f6e2ab8534e64196';
export default node;
